"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _FavoriteButton = _interopRequireDefault(require("../FavoriteButton"));

var _CompareIconButton = _interopRequireDefault(require("../CompareIconButton"));

var useStyles = (0, _makeStyles.default)(function () {
  return (
    /* theme*/
    {
      root: {
        display: 'flex'
      },
      button: {
        width: 'auto'
      }
    }
  );
}, {
  name: 'ProductListItemCardActions'
});

function ProductListItemCardActions(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product", "renderToGridArea"]);
  var classes = useStyles({
    classes: pClasses
  });
  var theme = (0, _useTheme.default)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  return !mobile ? /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    renderToGridArea: renderToGridArea
  }), /*#__PURE__*/_react.default.createElement(_CompareIconButton.default, {
    product: product,
    className: classes.button
  }), /*#__PURE__*/_react.default.createElement(_FavoriteButton.default, {
    product: product,
    className: classes.button
  })) : null;
}

process.env.NODE_ENV !== "production" ? ProductListItemCardActions.propTypes = {
  classes: _propTypes.default.shape({
    button: _propTypes.default.string,
    colored: _propTypes.default.string,
    icon: _propTypes.default.string,
    iconContainer: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    id: _propTypes.default.string
  }),
  renderToGridArea: _propTypes.default.string
} : void 0;
ProductListItemCardActions.defaultProps = {
  classes: undefined,
  className: undefined,
  product: undefined,
  renderToGridArea: 'actions'
};
var _default = ProductListItemCardActions;
exports.default = _default;